exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* styles in src/style directory are applied to the whole page */\nbody {\n  font-family: Arial, Helvetica, sans-serif;\n  background-color: #777777; }\n\n.app__topMenu {\n  background-color: transparent;\n  max-height: 60px; }\n\nmain {\n  display: block;\n  margin-left: 250px;\n  height: 100%; }\n\nfooter {\n  text-align: center;\n  font-size: 0.8em; }\n\n.app__content {\n  margin: 1em; }\n\n.app__topMenu__progress {\n  height: 2px; }\n\n@media (max-width: 768px) {\n  main {\n    margin-left: 0; }\n  .app__topMenu {\n    max-height: max-content; }\n  .app__topMenu__row__col {\n    height: 50px; }\n  .app__topMenu__row__col__menu {\n    display: block !important; }\n  .app__topMenu__row__col__language__text {\n    display: none; }\n  .app__content {\n    margin: 1em 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/app.css
// module id = 516
// module chunks = 0